import React from 'react';

interface ComingSoonCellProps {
  language?: 'fa' | 'en';
  isDark?: boolean;
}

const ComingSoonCell: React.FC<ComingSoonCellProps> = ({
  language = 'fa',
  isDark = document.documentElement.classList.contains('dark'),
}) => (
  <span
    data-tooltip-id="coming-soon-tooltip-global"
    data-tooltip-content={language === 'fa' ? 'به‌زودی' : 'Coming soon'}
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
      color: isDark ? 'rgb(107, 114, 128)' : 'rgb(156, 163, 175)',
      cursor: 'default',
      userSelect: 'none',
    }}
  >
    —
  </span>
);

export default ComingSoonCell;
